import { queryKeyFilters } from 'constants/url'
import { isEmpty } from 'lib/array/arrayUtils'

export default function isAnyFilterApplied(params?: Record<string, string> | App.OfferListFilters): boolean {
  return !isEmpty(params) && queryKeyFilters.some(filterKey => !isEmpty(params![filterKey]))
}
